
<!--
NOTE:
    Make sure resizeContainers is true ONLY when NOT the header toolbar (!inHeader).

      [resizeContainers]="!inHeader && (maximizeTitle || hideToolbarButtons)"

    - Seeing odd behaviour when used in the header toolbar.
    - header toolbar is reused a lot throught the app. maybe too many changes for sohoxi to keep up with??? not sure,
    [blockUI]="true"
-->
<ng-container *ngIf="asOfDateMode || ((secSessionDebugMode || dbSessionDebugMode) && inHeader)">
  <span class="as-of-date-span">
    <button
        *ngIf="asOfDateMode"
        id="as-of-date-button"
        class="as-of-date-button"
        (click)="clearAsOfDate($event)"
        soho-button icon="close" isToggle="true"
        soho-tooltip [content]="clearAsOfDateTooltip">
    <span class="audible">{{asOfDateTitle}}</span>{{asOfDateTitle}}</button>
    <div *ngIf="dbSessionDebugMode && inHeader" class="font-size-px-16 db-debug-session-indicator" title="Session Id: {{dbSessionDebugId}}">{{dbDebugActiveString}}({{dbDebugLevel}}) {{dbSessionTraceString}}</div>
    <div *ngIf="secSessionDebugMode && inHeader" class="font-size-px-16 db-debug-session-indicator">{{secDebugActiveString}}</div>
  </span>
</ng-container>

<soho-toolbar-flex
  #SohoToolbarComponent
    soho-busyindicator
    [text]="' '"
    [overlayOnly]="true"
    [transparentOverlay]="true"
    [timeToComplete]="500"
    [moreMenuBeforeOpenFunction]="moreMenuSettings?.beforeOpen"
    class="flex-toolbar-main-app-content "
    [ngClass]="{'disableBackground':disableToolbar}"
    (selected)="onFlexItemSelected($event)"
    [attributes]="toolbarAttributes"
>
  <ng-container *ngIf="!hideToolbarTitles">

    <ng-container *ngIf="inHeader">
      <!-- in header -->
      <soho-toolbar-flex-section>
        <ng-container *ngIf="!hideNavBar">
          <button
            id="app-menu-trigger"
            data-automation-id="lm-toolbar-app-menu-trigger"
            [ngStyle]="{'vertical-align': 'middle', 'padding': '0px'}"
            class="btn-icon application-menu-trigger"
            type="button"
            soho-tooltip content="{{menuToolTip}}"
            (click)="onAppMenuTrigger($event)">
              <span class="icon app-header" [ngClass]="{ 'go-back': goBack }">
                <span class="one"></span>
                <span class="two"></span>
                <span class="three"></span>
              </span>
              <span class="audible">{{dbDebugActiveString}} {{toggleNavigationString}}</span>
          </button>
        </ng-container>
      </soho-toolbar-flex-section>
      <soho-toolbar-flex-section [isTitle]="true" [isTitleFavor]="!hideOverflowMenuButton">
        <h1 class='titleHeader'>
          <ng-container *ngIf="sectionTitle">
            <span attr.id={{toolbarTitleId}} attr.data-automation-id="lm-{{automationId}}-toolbar-title" class='page-title'>{{sectionTitle}}</span>
          </ng-container>
          <ng-container *ngIf="showRecordSet">
            <header class="lm-list-header-record-count result-set-in-header">{{recordTotalString}}</header>
          </ng-container>
        </h1>
      </soho-toolbar-flex-section>
    </ng-container>

    <ng-container *ngIf="!inHeader">
      <!-- if not in the header -->

      <!--todo ppatton - kludge for now - need markup/style from soho so that the icon will be correctly vertically aligned.-->
      <ng-container  *ngIf="showListDetailBackButton" >
        <soho-toolbar-flex-section>
          <div class="lm-list-detail-back-button-container">
            <button soho-button="btn-icon"
                class="btn-icon list-detail-back-button secondary"
                [style.vertical-align]="'top'"
                [icon]="'bullet-steps'"
                soho-tooltip [content]="'Show Filter List'"
            ></button>
          </div>
        </soho-toolbar-flex-section>
      </ng-container>

      <soho-toolbar-flex-section [isTitle]="true" [isTitleFavor]="true" >
        <h2>
          <span
              attr.id="{{toolbarTitleId}}"
              attr.data-automation-id="lm-{{automationId}}-toolbar-title"
          >{{sectionTitle}}</span>
          <ng-container *ngIf="showRecordSet">
            <header class="lm-list-header-record-count result-set-not-in-header">{{recordTotalString}}</header>
          </ng-container>
        </h2>
      </soho-toolbar-flex-section>

    </ng-container>

  </ng-container>
  <ng-container *ngIf="searchField">
    <soho-toolbar-flex-section [isSearch]="true">
      <!-- LMCLIENT-40456: adding 'has-collapse-button' before jQuery control does to fix shifting issue -->
      <span
          id="{{toolbarId}}_searchfield"
          attr.data-automation-id="lm-{{automationId}}-toolbar-searchfield"
          [ngClass]="{'searchfield-wrapper toolbar-searchfield-wrapper': true, 'has-collapse-button': searchField.collapsible}"
      >
        <input soho-toolbar-flex-searchfield
            placeholder="{{searchField?.label}}"
            [(ngModel)]="searchField.value"
            [options]="searchField"
            [clearable]="true"
            [attr.disabled]="disabled ? 'disabled' : null"
            (keydown.enter)="fireSearchEvent($event)"
            (cleared)="fireClearSearchEvent($event)"
        />
      </span>
    </soho-toolbar-flex-section>
  </ng-container>

  <soho-toolbar-flex-section [isButtonSet]="true">

    <!-- toolbar buttons -->

    <ng-container *ngFor="let b of flexButtonSetButtons; trackBy: trackButton">
        <ng-container *ngIf="displayAsLink(b)">
          <a href="javascript:void(0);" class="hyperlink" attr.data-action-reference="{{stringifyJson(b?.actionReference)}}">View All</a>
        </ng-container>

<!--      attr.attributes="[{ name: 'data-automation-id', value: 'lm-{{b?.automationId}}-toolbar-button' }]"-->
      <ng-container *ngIf="isCustomButton(b) && !displayAsLink(b)">
        <ng-container *ngIf="!isCustomMenuButton(b)">
          <button soho-button="btn"
              attr.id="{{elementId(b?.customToolbarButtonInfo?.id)}}"
              attr.data-automation-id="lm-{{b?.automationId}}-toolbar-button"
              attr.attributes="[{'name': 'data-automation-id', 'value': 'lm-{{b?.automationId}}-toolbar-button'}]"
              [icon]="b?.customToolbarButtonInfo?.icon"
              [attr.disabled]="b.state?.disabled || disabled ? 'disabled' : null"
              attr.data-custom-toolbar-button-info="{{stringifyJson(b?.customToolbarButtonInfo)}}"
              soho-tooltip [content]="b?.customToolbarButtonInfo?.tooltip ? b?.customToolbarButtonInfo?.tooltip : b?.customToolbarButtonInfo?.text"
          >{{b?.customToolbarButtonInfo?.text}}<ng-container *ngIf="!(!!b?.customToolbarButtonInfo?.text)">
              <span class="audible">{{b?.customToolbarButtonInfo?.tooltip}}</span>
            </ng-container>
          </button>
        </ng-container>

        <ng-container *ngIf="isCustomMenuButton(b)">
          <button
              soho-menu-button
              attr.id="{{elementId(b?.customToolbarButtonInfo?.id)}}"
              attr.data-automation-id="lm-{{automationId}}-{{b?.customToolbarButtonInfo?.id}}-toolbar-button"
              attr.attributes="[{'name': 'data-automation-id', 'value': 'lm-{{automationId}}-{{b?.customToolbarButtonInfo?.id}}-toolbar-button'}]"
              [hideMenuArrow]="b?.customToolbarButtonInfo?.hideMenuArrow"
              attr.data-custom-toolbar-button-info="{{stringifyJson(b?.customToolbarButtonInfo)}}"
              [icon]="b?.customToolbarButtonInfo?.icon"
              menu="{{b?.customToolbarButtonInfo?.id}}_menu"
              [attachToBody]="true"
              [removeOnDestroy]="true"
              [attr.disabled]="b.state?.disabled || disabled ? 'disabled' : null"
              soho-tooltip [content]="b?.customToolbarButtonInfo?.tooltip ? b?.customToolbarButtonInfo?.tooltip : b?.customToolbarButtonInfo?.text"
          >{{b?.customToolbarButtonInfo?.text}}<ng-container *ngIf="!(!!b?.customToolbarButtonInfo?.text)">
              <span class="audible">{{b?.customToolbarButtonInfo?.tooltip}}</span>
            </ng-container>
          </button>

          <div class="popupmenu-wrapper bottom" role="application" aria-hidden="true">
            <ul class="popupmenu is-selectable" id="{{b?.customToolbarButtonInfo?.id}}_menu">
              <li
                  *ngFor="let menuItem of b?.customToolbarButtonInfo?.menu"
                  id="{{menuIdV1(menuItem?.id)}}"
                  [ngClass]="{
                  'separator': menuItem.customToolbarButtonInfo?.type === separator,
                  'disabled': menuItem.state?.disabled || disabled ? 'disabled' : null,
                  'is-checked': menuItem?.isChecked}"
                  title="{{b?.customToolbarButtonInfo?.tooltip}}"
              >
                <!-- Only put the a in if not a separator. If this is here, we get a blank value in the list -->
                <ng-container *ngIf="menuItem.customToolbarButtonInfo?.type !== separator">
                  <a
                          href="#"
                          id="{{menuIdV2(menuItem?.id)}}"
                          attr.data-custom-toolbar-button-info="{{stringifyJson(menuItem?.customToolbarButtonInfo)}}"
                          title="{{menuItem?.customToolbarButtonInfo?.tooltip}}"
                  >{{menuItem?.customToolbarButtonInfo?.text}}</a>
                </ng-container>
              </li>
            </ul>
          </div>
        </ng-container>

      </ng-container>
      <ng-container *ngIf="!isCustomButton(b) && !displayAsLink(b)">
        <!-- The ngClass is needed here to maintain the order of classes. Without this, css rules are breaking. Added for LMCLIENT-32061 -->
        <ng-container *ngIf="isDefaultButton(b)">
          <button soho-button="btn"
              id="{{this.elementId(b?.id)}}"
              attr.data-automation-id="lm-{{b?.automationId}}-toolbar-button"
              attr.attributes="[{'name': 'data-automation-id', 'value': 'lm-{{b?.automationId}}-toolbar-button'}]"
              attr.data-action-reference="{{stringifyJson(b?.actionReference)}}"
              class="btn hide-focus has-tooltip {{testVersion1 ? b?.actionReference?.id : ''}}"
              [ngClass]="{'lm-flex-icon-button': b?.isIconOnly}"
              [isToggle]="b?.isToggle"
              [isTogglePressed]="b.state?.isPressed"
              [icon]="b?.icon"
              [attr.disabled]="b.state?.disabled || disabled ? 'disabled' : null"
              soho-tooltip [content]="b?.actionReference?.tooltip ? b?.actionReference?.tooltip : b?.actionReference?.label"
          >{{b?.actionReference?.label}}<ng-container *ngIf="!(!!b?.actionReference?.label)">
              <span class="audible">{{b?.actionReference?.tooltip}}</span>
            </ng-container>
          </button>
        </ng-container>

        <ng-container *ngIf="isMenuButton(b)">
          <!-- The ngClass is needed here to maintain the order of classes. Without this, css rules are breaking. Added for LMCLIENT-32061 -->
          <button
              soho-menu-button
              attr.id="{{elementId(b?.id)}}"
              attr.data-automation-id="lm-{{b?.automationId}}-toolbar-button"
              attr.attributes="[{'name': 'data-automation-id', 'value': 'lm-{{b?.automationId}}-toolbar-button'}]"
              attr.action-ref-type="{{b?.actionReference?.id}}"
              attr.data-action-reference="{{stringifyJson(b?.actionReference)}}"
              class="btn-menu hide-focus has-tooltip {{testVersion1 ? b?.actionReference?.id : ''}}"
              [ngClass]="{'lm-flex-icon-button': b?.isIconOnly}"
              [icon]="b?.icon"
              [menu]="b?.actionReference?.id + '_menu'"
              [attachToBody]="true"
              [removeOnDestroy]="true"
              [attr.disabled]="b.state?.disabled || disabled ? 'disabled' : null"
              soho-tooltip [content]="b?.actionReference?.tooltip ? b?.actionReference?.tooltip : b?.actionReference?.label"
          >{{b?.actionReference?.label}}<ng-container *ngIf="!(!!b?.actionReference?.label)">
              <span class="audible">{{b?.actionReference?.tooltip}}</span>
            </ng-container>
          </button>

          <div class="popupmenu-wrapper bottom" role="application" aria-hidden="true">
            <ul class="popupmenu" id="{{b?.actionReference?.id}}_menu">
              <li
                  *ngFor="let menuItem of b.menu"
                  [ngClass]="{
                    'separator': menuItem.actionReference?.type === separator,
                    'disabled': menuItem.state?.disabled || disabled ? 'disabled' : null,
                    'is-checked': menuItem?.isChecked
                  }"
                  class="{{menuItem?.actionReference?.id}}"
                  title="{{menuItem?.actionReference?.tooltip}}"
                  id="{{menuIdV1(menuItem?.actionReference?.id)}}"
              >
                <!-- Only put the a in if not a separator. If this is here, we get a blank value in the list -->
<!--                id="{{menuItem?.actionReference?.id}}_anchor"-->
                <ng-container *ngIf="menuItem.actionReference?.type !== separator">
                  <a href="#"
                      attr.data-action-reference="{{stringifyJson(menuItem?.actionReference)}}"
                      title="{{menuItem?.actionReference?.tooltip}}"
                      attr.id="{{menuIdV2(menuItem?.id)}}"
                      attr.data-automation-id="lm-{{menuItem?.automationId}}-toolbar-menuitem"
                      attr.attributes="[{'name': 'data-automation-id', 'value': 'lm-{{menuItem?.automationId}}-toolbar-menuitem'}]"
                  >{{menuItem?.actionReference?.label}}</a>
                </ng-container>
              </li>
            </ul>
          </div>
        </ng-container>

        <ng-container *ngIf="isRelatedMenuButton(b)">
          <!-- The ngClass is needed here to maintain the order of classes. Without this, css rules are breaking. Added for LMCLIENT-32061 -->
<!--          attr.data-automation-attributes="{'attributes': [{'name': 'data-automation-id', 'value': 'lm-{{b?.automationId}}-toolbar-button'}]}"-->
          <button
            #relatedMenu
              soho-menu-button
              attr.id="{{elementId(b?.id)}}"
              attr.data-automation-id="lm-{{b?.automationId}}-toolbar-button"
              attr.attributes="[{'name': 'data-automation-id', 'value': 'lm-{{b?.automationId}}-toolbar-button'}]"
              attr.data-action-reference="{{stringifyJson(b?.actionReference)}}"
              class="btn-menu hide-focus has-tooltip {{testVersion1 ? b?.actionReference?.id : ''}}"
              [ngClass]="{'lm-flex-icon-button': b?.isIconOnly}"
              [icon]="b?.icon"
              [attachToBody]="true"
              [removeOnDestroy]="true"
              [attr.disabled]="b.state?.disabled || disabled ? 'disabled' : null"
              soho-tooltip [content]="b?.actionReference?.tooltip ? b?.actionReference?.tooltip : b?.actionReference?.label"
          ><span>{{b?.actionReference?.label}}</span><ng-container *ngIf="!(!!b?.actionReference?.label)">
              <span class="audible">{{b?.actionReference?.tooltip}}</span>
            </ng-container>
          </button>
          <ul *ngIf="displayRelatedButtonPopupMenu(b)" class="popupmenu" attr.data-action-reference="{{stringifyJson(b?.actionReference)}}"></ul>
        </ng-container>
      </ng-container>
    </ng-container>
  </soho-toolbar-flex-section>
  <ng-container *ngIf="useEmptyMoreButton; else normalMoreMenu">
    <soho-toolbar-flex-more-button [moreButtonId]="toolbarMoreButtonId"></soho-toolbar-flex-more-button>
  </ng-container>
  <ng-template #normalMoreMenu>
    <ng-container *ngIf="flexMoreButtons?.length > 0">
<!--      attributes="[{'name': 'data-automation-id', 'value': 'lm-{{automationId}}-toolbar-more-button'}]"-->
      <soho-toolbar-flex-more-button
          attr.id="{{testVersion1 ? toolbarId + '_morebutton' : ''}}"
          [moreButtonId]="toolbarMoreButtonId"
          attr.data-automation-id="lm-{{automationId}}-toolbar-more-button"
      >
        <ul class="popupmenu">
          <ng-container *ngIf="moreMenuSettings?.beforeOpen">
            <li>Placeholder</li>
          </ng-container>

          <ng-container *ngIf="!moreMenuSettings?.beforeOpen">
            <li
                *ngFor="let menuItem of flexMoreButtons"
                class="btn {{testVersion1 ? menuItem?.customToolbarButtonInfo?.id : ''}}"
                title="{{menuItem?.customToolbarButtonInfo?.tooltip}}"
                [attr.disabled]="menuItem.state?.disabled || disabled ? 'disabled' : null"
                attr.data-custom-toolbar-button-info="{{stringifyJson(menuItem?.customToolbarButtonInfo)}}"
                attr.id="{{menuIdV1(menuItem?.customToolbarButtonInfo?.id)}}"
            >
              <a href="#"
                  attr.id="{{menuIdV2(menuItem?.customToolbarButtonInfo?.id)}}"
                  attr.data-custom-toolbar-button-info="{{stringifyJson(menuItem?.customToolbarButtonInfo)}}"
                  title="{{menuItem?.customToolbarButtonInfo?.tooltip}}"
              >{{menuItem?.customToolbarButtonInfo?.text}}</a>

            </li>
          </ng-container>
        </ul>
      </soho-toolbar-flex-more-button>
    </ng-container>
  </ng-template>
</soho-toolbar-flex>
